var map = {
	"./Afganistan.png": 79835,
	"./Albaania.png": 85474,
	"./Alžeeria.png": 583,
	"./AmeerikaÜhendriigid.png": 40483,
	"./Andorra.png": 2712,
	"./Angola.png": 24140,
	"./AntiguaJaBarbuda.png": 75587,
	"./AraabiaÜhendemiraadid.png": 41534,
	"./Argentiina.png": 86632,
	"./Armeenia.png": 48806,
	"./Aserbaidžaan.png": 42452,
	"./Austraalia.png": 27031,
	"./Austria.png": 4345,
	"./Bahama.jpg": 46217,
	"./Bahrein.png": 63850,
	"./Bangladesh.png": 1215,
	"./Barbados.png": 38597,
	"./Belau.png": 48457,
	"./Belgia.png": 66895,
	"./Belize.png": 48150,
	"./Benin.png": 42035,
	"./Bhutan.png": 79040,
	"./Boliivia.png": 29685,
	"./BosniaJaHertsegoviina.png": 57980,
	"./Botswana.png": 94942,
	"./Brasiilia.png": 92636,
	"./Brunei.png": 30477,
	"./Bulgaaria.png": 99891,
	"./BurkinaFaso.png": 89573,
	"./Burundi.png": 8893,
	"./CaboVerde.png": 85300,
	"./Colombia.png": 98554,
	"./CostaRica.png": 6601,
	"./CoteDivoire.png": 32063,
	"./Djibouti.png": 95978,
	"./Dominica.png": 43627,
	"./DominikaaniVabariik.png": 15919,
	"./Ecuador.png": 99161,
	"./Eesti.png": 56472,
	"./Egiptus.png": 36946,
	"./EkvatoriaalGuinea.png": 83911,
	"./ElSalvador.png": 14954,
	"./Eritrea.png": 80848,
	"./Etioopia.png": 49462,
	"./Fidži.png": 93452,
	"./Filipiinid.png": 48466,
	"./Gabon.png": 13727,
	"./Gambia.png": 12393,
	"./Ghana.png": 93346,
	"./Grenada.png": 94697,
	"./Gruusia.png": 41590,
	"./Guatemala.png": 60943,
	"./Guinea.png": 16716,
	"./GuineaBissau.png": 17287,
	"./Guyana.png": 553,
	"./Haiti.png": 49161,
	"./Hiina.png": 48497,
	"./Hispaania.png": 4669,
	"./Holland.png": 36237,
	"./Honduras.png": 93140,
	"./Horvaatia.png": 75947,
	"./IdaTimor.png": 98474,
	"./Iirimaa.png": 50905,
	"./Iisrael.png": 3161,
	"./India.png": 8302,
	"./Indoneesia.png": 987,
	"./Iraak.png": 94798,
	"./Iraan.png": 81162,
	"./Island.png": 63616,
	"./Itaalia.png": 93279,
	"./Jaapan.png": 22467,
	"./Jamaika.png": 87607,
	"./Jeemen.png": 29828,
	"./Jordaania.png": 17284,
	"./Kambodža.png": 73006,
	"./Kamerun.png": 8525,
	"./Kanada.png": 38113,
	"./Kasasthan.png": 91431,
	"./Katar.png": 36574,
	"./Keenia.png": 95183,
	"./KeskAafrikaVabariik.png": 60317,
	"./Kiribati.png": 11335,
	"./Komoorid.png": 84118,
	"./KongoDV.png": 93407,
	"./KongoVabariik.png": 34972,
	"./Kosovo.png": 16968,
	"./Kreeka.png": 5470,
	"./Kuuba.png": 89791,
	"./Kuveit.png": 26513,
	"./Kõrgõzstan.png": 47680,
	"./Küpros.png": 12073,
	"./Laos.png": 48400,
	"./Leedu.png": 6666,
	"./Lesotho.png": 37250,
	"./Libeeria.png": 38208,
	"./Liechtenstein.png": 32532,
	"./Liibanon.png": 67136,
	"./Liibüa.png": 65207,
	"./Luksemburg.png": 23527,
	"./Läti.png": 46462,
	"./LõunaAafrikaVabariik.png": 47747,
	"./LõunaKorea.png": 38059,
	"./LõunaSudaan.png": 62889,
	"./Madagaskar.png": 85065,
	"./Malaisia.png": 32245,
	"./Malawi.png": 11617,
	"./Maldiivid.png": 51159,
	"./Mali.png": 80185,
	"./Malta.png": 53094,
	"./Maroko.png": 75061,
	"./MarshalliSaared.png": 98829,
	"./Mauritaania.png": 59618,
	"./Mauritius.png": 40517,
	"./Mehhiko.png": 77829,
	"./Mikroneesia.png": 70313,
	"./Moldova.png": 93840,
	"./Monaco.png": 56491,
	"./Mongoolia.png": 63835,
	"./Montenegro.png": 42604,
	"./Mosambiik.png": 58422,
	"./Myanmar.png": 29381,
	"./Namiibia.png": 66058,
	"./Nauru.png": 7666,
	"./Nepali.png": 67449,
	"./Nicaragua.png": 71250,
	"./Nigeeria.png": 81119,
	"./Nigeri.png": 11572,
	"./Norra.png": 49870,
	"./Omaan.png": 81825,
	"./PaapuaUusGuinea.png": 60809,
	"./Pakistan.png": 15779,
	"./Panama.png": 88625,
	"./Paraguay.png": 66080,
	"./Peruu.png": 85331,
	"./Poola.png": 39796,
	"./Portugal.png": 15231,
	"./Prantsusmaa.png": 31249,
	"./PõhjaKorea.png": 61524,
	"./PõhjaMakedoonia.png": 7007,
	"./Rootsi.png": 73778,
	"./Rumeenia.png": 64271,
	"./Rwanda.png": 23689,
	"./SaalomoniSaared.png": 42388,
	"./SaintKittsJaNevis.png": 40103,
	"./SaintLucia.png": 69793,
	"./SaintVincentJaGrenadiinid.png": 83059,
	"./Saksamaa.png": 94633,
	"./Sambia.png": 92190,
	"./Samoa.png": 60855,
	"./SanMarino.png": 6585,
	"./SaoTomeJaPrincipe.png": 10634,
	"./SaudiAraabia.png": 1364,
	"./Seisellid.png": 90084,
	"./Senegal.png": 83892,
	"./Serbia.png": 6714,
	"./SierraLeone.png": 99196,
	"./Singapur.png": 22224,
	"./Slovakkia.png": 75132,
	"./Sloveenia.png": 30476,
	"./Somaalia.png": 79610,
	"./Soome.png": 51250,
	"./SriLanka.png": 20451,
	"./Sudaan.png": 61632,
	"./Suriname.png": 38480,
	"./Suurbritannia.png": 11605,
	"./Sveits.png": 76848,
	"./Süüria.png": 58435,
	"./Taani.png": 88120,
	"./Tadzikistan.png": 19655,
	"./Tai.png": 63675,
	"./Tansaania.png": 56908,
	"./Togo.png": 5579,
	"./Tonga.png": 12288,
	"./TrinidadJaTobago.png": 90717,
	"./Tsiili.png": 78352,
	"./Tuneesia.png": 91974,
	"./Tuvalu.png": 50381,
	"./Türgi.png": 78558,
	"./Türkmenistan.jpg": 69989,
	"./Tšaad.png": 60886,
	"./Tšehhi.png": 26444,
	"./Uganda.png": 35959,
	"./Ukraina.png": 46613,
	"./Ungari.png": 77922,
	"./Uruguay.png": 65715,
	"./Usbekistan.png": 32075,
	"./UusMeremaa.png": 4552,
	"./Valgevene.png": 48814,
	"./Vanuatu.png": 99229,
	"./Vatikan.png": 96274,
	"./Venemaa.jpeg": 37102,
	"./Venezuela.png": 20497,
	"./Vietnam.png": 77734,
	"./Zimbabwe.png": 39290,
	"./eSwatini.png": 89165
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 66984;